export const formatDate = (date: string) => {
    return new Intl.DateTimeFormat('en-GB').format(new Date(date)).replace(/\//g, '.');
};

const formatter = new Intl.DateTimeFormat('en', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    formatMatcher: 'basic',
}).format;

const rtf = new Intl.RelativeTimeFormat('en', {
    numeric: 'auto',
});

export function formatDateForPropertyRequests(dateString: string) {
    const date = new Date(dateString);
    const now = new Date();

    const diffTime = now.getTime() - date.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 2) {
        if (diffDays === 0) {
            return 'today';
        }
        return rtf.format(-diffDays, 'day');
    }

    return formatter(date).replace(/\//g, '.');
}
